// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Jotai from "jotai";
import * as UnifiedHelpersV2$OrcaPaymentPage from "./UnifiedHelpersV2.bs.js";

var paymentManagementList = Jotai.atom("LoadingV2");

var showAddScreen = Jotai.atom(false);

var managePaymentMethod = Jotai.atom("");

var savedMethodsV2 = Jotai.atom([UnifiedHelpersV2$OrcaPaymentPage.defaultCustomerMethods]);

export {
  paymentManagementList ,
  showAddScreen ,
  managePaymentMethod ,
  savedMethodsV2 ,
}
/* paymentManagementList Not a pure module */
